/* MIKADO cart-drawer.js v4 */
(function () {
  'use strict';
  const w = window, d = document;
  const $ = (sel, ctx) => (ctx || d).querySelector(sel);

  const routes = (w.mikado && w.mikado.routes) || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_update_url: '/cart/update', cart_url: '/cart' };

  function money(c) { return (w.mikado && w.mikado.formatMoney) ? w.mikado.formatMoney(c) : (c/100).toFixed(2).replace('.', ',') + ' €'; }

  const TRASH_SVG = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M19 6l-1.4 13.1a2 2 0 0 1-2 1.9H8.4a2 2 0 0 1-2-1.9L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/></svg>';
  const MINUS_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  const PLUS_SVG  = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';

  function updateHeaderCount(c) { const el = $('[data-cart-count]'); if (!el) return; el.textContent = c; el.setAttribute('data-count', c); }

  function imgUrl(item) {
    if (item.featured_image && item.featured_image.url) return item.featured_image.url.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|\d+x\d*)\./, '_160x160.');
    if (item.image) return item.image;
    return '';
  }
  function esc(s) { if (s == null) return ''; return String(s).replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }

  function renderLines(ul, cart) {
    ul.innerHTML = cart.items.map(item => `
      <li class="cart-line" data-cart-line data-line-key="${esc(item.key)}">
        <a href="${item.url}" class="cart-line__media link-plain">
          <img src="${imgUrl(item)}" width="80" height="80" alt="${esc(item.product_title)}" loading="lazy" decoding="async">
        </a>
        <div class="cart-line__info">
          ${item.vendor ? `<p class="cart-line__vendor">${esc(item.vendor)}</p>` : ''}
          <a href="${item.url}" class="cart-line__title link-plain">${esc(item.product_title)}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-line__variant">${esc(item.variant_title)}</p>` : ''}
          <div class="cart-line__actions">
            <div class="quantity quantity--compact">
              <button type="button" class="quantity__btn" data-cart-decrement aria-label="Diminuer">${MINUS_SVG}</button>
              <input type="number" value="${item.quantity}" min="0" class="quantity__input" data-cart-quantity aria-label="Quantité">
              <button type="button" class="quantity__btn" data-cart-increment aria-label="Augmenter">${PLUS_SVG}</button>
            </div>
            <button type="button" class="cart-line__remove" data-cart-remove aria-label="Retirer cet article">${TRASH_SVG}</button>
          </div>
        </div>
        <div class="cart-line__price" data-line-price>${money(item.final_line_price)}</div>
      </li>
    `).join('');
  }

  async function refreshDrawer() {
    try {
      const r = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await r.json();
      updateHeaderCount(cart.item_count);
      const drawer = $('#mikado-cart-drawer'); if (!drawer) return cart;
      const sub = $('[data-cart-subtotal]', drawer); if (sub) sub.textContent = money(cart.total_price);
      const cl = $('[data-cart-count-label]', drawer); if (cl) cl.textContent = '(' + cart.item_count + ')';
      const empty = $('[data-cart-empty]', drawer);
      const footer = $('[data-cart-footer]', drawer);
      const lines = $('[data-cart-lines]', drawer);
      if (cart.item_count === 0) {
        if (empty) empty.hidden = false;
        if (footer) footer.hidden = true;
        if (lines) { lines.hidden = true; lines.innerHTML = ''; }
      } else {
        if (empty) empty.hidden = true;
        if (footer) footer.hidden = false;
        if (lines) { lines.hidden = false; renderLines(lines, cart); }
      }
      return cart;
    } catch (e) { console.warn('[mikado] cart refresh failed', e); }
  }
  w.mikado = w.mikado || {}; w.mikado.refreshCart = refreshDrawer;

  d.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-mikado-product-form]'); if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[data-add-to-cart]');
    if (btn) { btn.disabled = true; const t = btn.querySelector('[data-add-to-cart-text]'); if (t) t.textContent = 'Ajout…'; }
    const fd = new FormData(form);
    try {
      const res = await fetch(routes.cart_add_url + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Erreur ajout panier');
      await refreshDrawer();
      w.mikado.openDrawer && w.mikado.openDrawer('#mikado-cart-drawer');
      w.mikado.toast && w.mikado.toast((w.mikado.strings && w.mikado.strings.addedToCart) || 'Ajouté au panier');
      if (w.dataLayer) {
        w.dataLayer.push({ event: 'add_to_cart', ecommerce: { currency: (w.mikado.shop && w.mikado.shop.currency) || 'EUR', value: (data.price || 0)/100, items: [{ item_id: data.product_id, item_name: data.product_title, item_brand: data.vendor, item_variant: data.variant_title, price: (data.price || 0)/100, quantity: data.quantity }] } });
      }
    } catch (err) {
      console.warn('[mikado] ATC failed', err);
      w.mikado.toast && w.mikado.toast(err.message || ((w.mikado.strings && w.mikado.strings.cartError) || 'Erreur'));
    } finally {
      if (btn) { btn.disabled = false; const t = btn.querySelector('[data-add-to-cart-text]'); if (t) t.textContent = 'Ajouter au panier'; }
    }
  });

  async function changeLine(key, qty) {
    const r = await fetch(routes.cart_change_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
    return r.json();
  }

  d.addEventListener('click', async (e) => {
    const line = e.target.closest('[data-cart-line]'); if (!line) return;
    const key = line.dataset.lineKey; if (!key) return;
    if (e.target.closest('[data-cart-remove]')) {
      e.preventDefault();
      try { await changeLine(key, 0); await refreshDrawer(); w.mikado.toast && w.mikado.toast((w.mikado.strings && w.mikado.strings.removedFromCart) || 'Article retiré'); }
      catch (err) { console.warn(err); }
      return;
    }
    const dec = e.target.closest('[data-cart-decrement]');
    const inc = e.target.closest('[data-cart-increment]');
    if (dec || inc) {
      e.preventDefault();
      const input = line.querySelector('[data-cart-quantity]'); if (!input) return;
      let v = parseInt(input.value, 10) || 1; v = dec ? Math.max(0, v - 1) : v + 1;
      try { await changeLine(key, v); await refreshDrawer(); } catch (err) { console.warn(err); }
    }
  });

  let qt = null;
  d.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-quantity]'); if (!input) return;
    const line = input.closest('[data-cart-line]'); if (!line) return;
    const key = line.dataset.lineKey;
    const v = Math.max(0, parseInt(input.value, 10) || 0);
    clearTimeout(qt);
    qt = setTimeout(async () => { try { await changeLine(key, v); await refreshDrawer(); } catch (err) { console.warn(err); } }, 250);
  });

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', refreshDrawer);
  else refreshDrawer();
})();
